@import "@/scss/use-bootstrap-mixins.scss";

.container {
  &.primary {
    padding: 0 0 20px 0;

    .header.right {
      .error,
      .success {
        color: #fff;
      }
    }
  }

  &.base {
    padding: 20px 0;

    .header {
      .right {
        .error {
          color: red !important;
        }

        .success {
          color: green !important;
        }
      }
    }
  }

  .header {
    display: flex;
    gap: 6px;
    margin-bottom: 10px;
    flex-direction: column;
    // justify-content: space-between;

    @include iPhoneX {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .left {
      display: flex;
      gap: 6px;
      align-items: center;
    }

    .right {
      font-size: 12px;
    }
  }

  &.primary .header {
    svg {
      path {
        fill: $textColorOnPrimary;
      }
    }
  }

  &.base .header {
    svg {
      path {
        fill: #000;
      }
    }
  }

  .body {
    display: flex;
    border-radius: 14px;

    .input {
      flex: 1;
      border-radius: 14px 0 0 14px;
      padding: 10px;
      font-size: 12px;
      border: none;

      @include media-breakpoint-up(sm) {
        font-size: 14px;
      }

      @include iPhoneX {
        padding: 18px 20px;
      }

      &:disabled {
        opacity: 0.2;
      }

      &:focus-visible,
      &:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    }

    .button {
      border-radius: 14px;
      padding: 12px;
      font-size: 16px;
      border: 2px solid;

      @include iPhoneX {
        padding: 18px;
      }
    }
  }

  &.primary .body {
    background-color: #fff;

    .input {
      background-color: #fff;
    }

    .button {
      background-color: #fff;
      color: $primary;
      border-color: $primary;
    }
  }

  &.base .body {
    background-color: #f5f5f5;

    .input {
      background-color: #f5f5f5;
    }

    .button {
      background-color: #fff;
      border-color: $primary;
      color: $primary;
    }
  }
}
